import { useState, useEffect, useCallback } from 'react'
import { Button } from '@bosch/react-frok'
import type { MessageContextMenuItem } from './types/MessageContextMenuTypes'

interface SVGIconButtonProps {
    item: MessageContextMenuItem;
}

const SVGIconButton = ({ item }: SVGIconButtonProps) => {
    const iconObj = typeof item.icon === 'string' ? null : item.icon
    const iconSrc = iconObj?.src
    const iconHoverSrc = iconObj?.hoverSrc
    const [currentIcon, setCurrentIcon] = useState(iconSrc ?? '')

    // Sync state when icon prop changes
    useEffect(() => {
        if (iconSrc !== undefined) {
            setCurrentIcon(iconSrc)
        }
    }, [iconSrc])

    const handleMouseEnter = useCallback(() => {
        if (iconHoverSrc) {
            setCurrentIcon(iconHoverSrc)
        }
    }, [iconHoverSrc])

    const handleMouseLeave = useCallback(() => {
        if (iconSrc !== undefined) {
            setCurrentIcon(iconSrc)
        }
    }, [iconSrc])

    if (!iconObj) return null

    return (
        <Button
            title={item.label}
            onClick={item.onClick}
            className='message-context-menu-button'
            mode='integrated'
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <img src={currentIcon} alt={item.label} className='message-context-menu-icon' />
        </Button>
    )
}

export default SVGIconButton
